import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to top on route change, but respects in-page anchor links (#).
const ScrollToTop = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) return;
        window.scrollTo(0, 0);
    }, [pathname, hash]);
    return null;
};

export default ScrollToTop;
